import BaseService from '@/services/BaseService'
import {http} from './config'

class EstoqueService extends BaseService {
    constructor(){
        super('/v1/estoques')
    }
    async transferir(data){
        await http.post(`/v1/estoque/transferencia`, data)
    }
    async imprimir(data){
        const queryParam = `estoqueId=${data.estoqueId ? data.estoqueId : ''}`
        return await http.post(`/v1/estoque/relatorio?${queryParam}`, data)
    }
    async movimentacao(data){
        return await http.post(`/v1/estoque/movimentacao`, data)
    }
}

export default new EstoqueService